<template>
    <div class="colorselection" role="group">

        <label v-bind:key="color" v-for="color in firstColors" v-bind:class="['btn', selectedColor === color ? 'active' : '', color === '#ffffff' ? 'whiteborder' : '', color === 'white' ? 'whiteborder' : '' ]" v-bind:style="{ background: color }" v-on:click="$emit('select-color', color)">
            <input type="radio" name="color_text" v-bind:value="color" style="display: none;">
        </label>

        <button class="btn toggle_colors" v-on:click="toggleMoreColors = !toggleMoreColors" v-if="remainingColors.length > 0">
            <img src="../assets/pantone.png">
        </button>

        <transition name="slide">
            <div v-if="toggleMoreColors">
                <label v-bind:key="color" v-for="color in remainingColors" v-bind:class="[ 'btn', selectedColor === color ? 'active' : '' ]" v-bind:style="{ background: color }" v-on:click="$emit('select-color', color)">
                </label>
            </div>
        </transition>

    </div>
</template>

<script>
export default {
    name: 'ColorSelection',

    data: function () {
        return {
            initialPageSize: 6,
            toggleMoreColors: false,
        }
    },

    props: {
        colors: Array,
        selectedColor: String
    },

    computed: {

        firstColors() {
            return this.colors.slice(0, this.initialPageSize);
        },

        remainingColors() {
            if (this.colors.length > this.initialPageSize) 
                return this.colors.slice(this.initialPageSize, this.colors.length);
            else return [];
        },
    }

}
</script>